import { httpRequest } from '@/api/HttpRequest';
import { AdminTicketType, CalendarTicketType, GeneralProductType, ProductType } from '@/types/TicketType';

export async function getTickets(ids: number[]) : Promise<Array<ProductType>> {

  const fetches = ids.map(ticketId => httpRequest('GET', `${process.env.NEXT_PUBLIC_API_BASE_URL}/products/${ticketId}?cached=1`))
  const results = await Promise.all(fetches)

  const products: Array<ProductType> = (

    await Promise.all(results.map(result => {

    if (result.status === 200) {
      return result.json()
    } else {
      return null
    }
  }))).filter((product: ProductType) => product !== null);

  return products.filter(product => product !== null) as Array<ProductType>
}

export async function getDiscoveryCoveTicketWithDates(ticketId: string, dateFrom: string, dateTo: string) : Promise<CalendarTicketType | undefined> {

  const result = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/products/${ticketId}?cached=1&view=website&fields=sale_cur,tickets/ticket_id,tickets/type,tickets/type_description,tickets/price_from,tickets/availability,tickets/internal/is_hidden,price_options,seasons/date_from,seasons/date_to,seasons/theme,seasons/tickets,seasons/tickets/rrp/days&date_from=${dateFrom}&date_to=${dateTo}`)

  if (result.status === 200) {
    const ticketResult = await result.json()

    if (ticketResult) {
      return ticketResult as CalendarTicketType
    } else {
      console.warn('Unexpected product result', ticketResult)
    }

  } else {
    console.warn('Unexpected status code', result.status)
  }

}

export async function getAdminTickets() : Promise<Array<AdminTicketType>> {

  const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/products?limit=100&cached=1`)

  if (res.status === 200) {
    const products : GeneralProductType = await res.json()

    if (products) {

      const adminTickets = products.data.map((product: AdminTicketType) => {
        return {
          id: product.id,
          title: product.title
        }
      })

      return adminTickets

    } else {
      console.warn('Unexpected product result', products)
    }
  } else {
    console.warn('Unexpected status code', res.status)
  }

  return []
}
